import React from "react";

const GlideSlide = ({ product, onAdd }) => {
  return (
    <li className="glide__slide">
      <div className="arrival">
        <div className="cart__like">
          <div className="image__holder">
            <img src={product.image} alt="" />
          </div>
          <div className="cart__details">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
            <div className="rating">
              <span>
                <svg>
                  <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                </svg>
              </span>
              <span>
                <svg>
                  <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                </svg>
              </span>
              <span>
                <svg>
                  <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                </svg>
              </span>
              <span>
                <svg>
                  <use xlinkHref="./images/sprite.svg#icon-star-full"></use>
                </svg>
              </span>
              <span>
                <svg>
                  <use xlinkHref="./images/sprite.svg#icon-star-empty"></use>
                </svg>
              </span>
            </div>
            <div className="colors">
              <span></span>
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="btn__group">
              <button onClick={() => onAdd(product)}>Add To Cart</button>
              <button>$75</button>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

export default GlideSlide;
